(function ($, gridBreakPoints) {
  function isBookingPage() {
    return typeof BOOKING_SETTINGS !== 'undefined';
  }

  function smoothScroll(hash) {
    const headerDesktop = 70;
    const headerMobile = 60;
    let height = $(window).width() > gridBreakPoints.lg ? headerDesktop : headerMobile;
    const adminBar = $('#wpadminbar');
    const duration = 700;

    if (adminBar.length) {
      height += adminBar.height();
    }

    const customOffset = height + 60;

    $('html,body').animate({ scrollTop: $(hash).offset().top - ($('.hero-menu') ? customOffset : height) }, duration);

    window.setTimeout(() => {
      $(document).trigger('afterSmoothScroll', [hash]);
    }, duration);
  }

  function catchHash() {
    let className = null;

    if (window.location.hash.length) {
      className = `.${window.location.hash.substring(1)}`;
    }

    if (isBookingPage() || window.location.hash.includes('/')) {
      return false;
    }

    if (!$(window.location.hash).length) {
      if (window.location.hash.length && $(className).length) {
        smoothScroll(className);
      }
    }

    if (window.location.hash) {
      smoothScroll(window.location.hash);
    }

    return false;
  }

  function getLocation(href) {
    const link = window.document.createElement('a');
    link.href = href;
    return link;
  }

  window.addEventListener('load', () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    setTimeout(() => {
      catchHash();
    }, 700);
  });

  const submenuLink = window.document.querySelectorAll('.nav__submenu-link[href*=\\#], .hero-menu__link[href*=\\#]');

  submenuLink.forEach((item) => {
    item.addEventListener('click', (event) => {
      if (isBookingPage()) {
        if (!$(event.target).hasClass('wpml-ls-native')) {
          event.preventDefault();
        }
        return false;
      }

      const itemLink = getLocation(item.href);
      const itemPathname = itemLink.pathname;
      const windowPathName = window.location.pathname;

      if (itemPathname.replace(/^\/|\/$/g, '') === windowPathName.replace(/^\/|\/$/g, '')) {
        event.preventDefault();
        window.history.pushState('', document.title, window.location.pathname + itemLink.hash);
        smoothScroll(itemLink.hash);
      }
      return false;
    });
  });

  // eslint-disable-next-line no-undef
}(jQuery, gridBreakPoints));
